export default __webpack_public_path__ + "c896add0fe88509f2c7894ff494648ac.png";